import { Box, ContentBlock, Heading, Stack } from 'braid-design-system';
import type { ReactElement, ReactNode } from 'react';

const TitleSection = ({
  title,
  subtitle,
}: {
  title: ReactNode;
  subtitle?: ReactElement;
}) => (
  <Box
    paddingTop="xlarge"
    paddingBottom={{ mobile: 'large', tablet: 'xlarge' }}
    data-automation="heading"
  >
    <ContentBlock width="large">
      <Stack space="large">
        <Heading level="2">{title}</Heading>
        {subtitle}
      </Stack>
    </ContentBlock>
  </Box>
);

export default TitleSection;
